module.exports = __webpack_public_path__ + "fonts/fa-brands-400.2ec1097c.ttf";